import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { useLocation } from 'react-router-dom';
import { withViewport } from '../../util/contextHelpers';
import { injectIntl, intlShape } from '../../util/reactIntl';
import config from '../../config';
import {
  Footer,
  LayoutSingleColumn,
  LayoutWrapperFooter,
  LayoutWrapperMain,
  LayoutWrapperTopbar,
  Page,
} from '../../components';
import { TopbarContainer } from '..';
import facebookImage from '../../assets/facebook_drivelah_2.jpg';
import twitterImage from '../../assets/facebook_drivelah_2.jpg';
import { pushGTMBrowseEvent } from '../../util/gtm/gtmHelpers';
import { EVENT_BROWSE_HOMEPAGE } from '../../util/gtm/gtmConstants';

import SectionStories from './SectionStories';
import { fetchPHVFeaturedCar } from '../SearchPage/SearchPage.duck';
import css from './RentAPHV.css';
import SectionCars from './SectionCars';
import SectionHelp from './SectionHelp';
import PHVIntroBanner from './PHVIntroBanner';
import DriveLahVsCompanies from './DriveLahVsCompanies';
import HostSectionHeroPartners from './HostSectionHeroPartners';
import { checkSignUpCode } from '../../util/referralProgram';
import { formatMoney } from '../../util/currency';
import { types } from '../../util/sdkLoader';
import { parse } from '../../util/urlHelpers';

const { Money } = types;
const MAX_MOBILE_SCREEN_WIDTH = 991;

export const RentAPHVComponent = props => {
  const {
    intl,
    scrollingDisabled,
    listings,
    fetchCategorisedCarInProgress,
    viewport,
  } = props;
  // Schema for search engines (helps them to understand what this page is about)
  // http://schema.org
  // We are using JSON-LD format
  const siteTitle = config.siteTitle;
  // const schemaTitle = intl.formatMessage({ id: 'SeoLandingPage.schemaTitle' }, { siteTitle });
  const [signUpCodeAmount, setSignUpCodeAmount] = useState(0);
  const [loading, setLoading] = useState(false);
  const schemaTitle = intl.formatMessage(
    {
      id: 'Rent a car in Singapore from us & earn with grab. Affordable rentals starting from $4/hr',
    },
    { siteTitle, amount: formatMoney(intl, new Money(signUpCodeAmount, config.currency)) }
  );
  const schemaDescription = intl.formatMessage({
    id:
      "Don't own a car but want to rent a car in Singapore and earn with grab? We got you covered. Say no to long leases & mileage cap with drive lah. Pay per use with flexible rentals.",
  });
  const schemaImage = `${config.canonicalRootURL}${facebookImage}`;
  const targetRef = useRef(null);
  const location = useLocation();
  const isScoot = location.pathname === '/scoot-drivelah-signup';

  useEffect(() => {
    const { code } = parse(location.search);
    if (code) {
      setLoading(true);
      checkSignUpCode(code).then(res => {
        if (res.valid) {
          setSignUpCodeAmount(res.credits);
        }
        setLoading(false);
      });
    }
  }, []);

  const onPushGTMEvent = (event, buttonId) => {
    // pushGTMBrowseEvent({
    //   props,
    //   event,
    //   buttonId,
    // });
  };

  useEffect(() => {
    onPushGTMEvent(EVENT_BROWSE_HOMEPAGE);
  }, []);

  let isMobileLayout;
  try {
    if (viewport) {
      isMobileLayout = viewport.width < MAX_MOBILE_SCREEN_WIDTH;
    }
  } catch (error) {

  }

  const handleGetToCalculatorSection = () => {
    window.scrollTo(0, targetRef.current.offsetTop - 72);
  };

  return (
    <Page
      className={css.root}
      scrollingDisabled={scrollingDisabled}
      contentType="website"
      description={schemaDescription}
      title={schemaTitle}
      facebookImages={[{ url: facebookImage, width: 1200, height: 630 }]}
      twitterImages={[
        { url: `${config.canonicalRootURL}${twitterImage}`, width: 600, height: 314 },
      ]}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        description: schemaDescription,
        name: schemaTitle,
        image: [schemaImage],
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer notApplySearch={true} currentPage="SeoLandingPage" />
        </LayoutWrapperTopbar>
        <LayoutWrapperMain className={css.contentWrapper}>
          <PHVIntroBanner
            isScoot={isScoot}
            signUpCodeAmount={signUpCodeAmount}
            loading={loading}
            isMobileLayout={isMobileLayout}
          />
          {/* <WhyHostWithDrivelah isMobileLayout={isMobileLayout} /> */}
          <DriveLahVsCompanies isMobileLayout={isMobileLayout} />
          <HostSectionHeroPartners
            isScoot={isScoot}
            signUpCodeAmount={signUpCodeAmount}
            loading={loading}
            getToCalculatorSection={handleGetToCalculatorSection}
          />
          <SectionCars
            listings={listings}
            isMobileLayout={isMobileLayout}
            fetchCategorisedCarInProgress={fetchCategorisedCarInProgress}
          />
          <SectionStories />
          <SectionHelp />
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </Page>
  );
};

const { bool, object, number, shape } = PropTypes;

RentAPHVComponent.propTypes = {
  scrollingDisabled: bool.isRequired,

  // from withRouter
  history: object.isRequired,
  location: object.isRequired,

  // from injectIntl
  intl: intlShape.isRequired,

  // from withViewport
  viewport: shape({
    width: number.isRequired,
    height: number.isRequired,
  }).isRequired,
};

const RentAPHV = compose(withViewport, injectIntl)(RentAPHVComponent);

RentAPHV.loadData = () => {
  return fetchPHVFeaturedCar();
};

export default RentAPHV;
